// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceController = function ($scope, $http, $routeParams, Invoice, Customer, InvoiceDownload, InvoiceResend,
  InvoiceBearerMedium, InvoiceDownloadByFilter, gettextCatalog, gettext, DunningsCount, PUtill, DatepickerUtils) {
    $scope.isL = false;
    $scope.dateRange = { dateFrom: null, dateTo: null };
    $scope.customerId = ($routeParams.customerId || '');
    
    function getSearchParams() {
        let searchParams = {
            search: $scope.search,
            customerId: $scope.customerId
        };
        
        DatepickerUtils.setSearchParamsWithStringRangeAndRaiseErrorIfNeeded($scope, searchParams, $scope.dateRange);

        return searchParams;
    }
    
    $scope.updateFilter = function (func) {
        $scope.documents = $scope.paginator(function (options, callback) {
            return Invoice.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };
    
    if (!$scope.search)
        $scope.search = "";
    
    $scope.updateFilter();
    updatedDunningsCount();

    $scope.download = function (id) {
        var downloadInfo = new InvoiceDownload();
        downloadInfo.$save({ invoiceId: id }, function () {
            window.location = downloadInfo.Url;
        });
    };

    $scope.resend = function (id) {
        InvoiceBearerMedium.get({ invoiceId: id }, {}, function (data) {
            var bearerMedium = data.BearerMedium,
                bearerMediumTranslated = gettextCatalog.getString(bearerMedium),
                dialogTitle = gettextCatalog.getString('Resend Document');

            if (bearerMedium != "ArchiveOnly") {

                $scope.yesCancel(dialogTitle,
                    gettextCatalog.getString(gettext('Do you want to resend the document using')) + ' ' + bearerMediumTranslated + '?',
                    function () {
                        InvoiceResend.save({ invoiceId: id }, {}, null);
                    });

            } else {
                $scope.onlyCancel(dialogTitle,
                    gettextCatalog.getString(gettext("Can not resend document, settings are for archiving only.")));
            }
        });
    };

    $scope.downloadByFilter = function () {
        if ($scope.isL)
            return;

        let searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {
            $scope.isL = true;
            var downloadInfo = new InvoiceDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                search: searchParams.search,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                customerId: searchParams.customerId
            }, function () {
                switch (true) {
                    case downloadInfo.IsFileCountExceeded:
                        $scope.notify("warning", gettextCatalog.getString(gettext("The maximum permissible number of documents 5000. Please refine your filter criteria.")));
                        break;
                    case downloadInfo.IsFileCountZero:
                        $scope.notify("warning", gettextCatalog.getString(gettext("No files match search criteria.")));
                        break;
                    default:
                        $scope.downloadFile(downloadInfo.Url);
                        break;
            }
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };
    $scope.sendInvoice = function (draftId) {
        $http({
            method: "POST",
            url: "/api/v1/Invoices/" + draftId,
            params: null,
            data: {},
            headers: {},
            cache: false
        }).then(function () {
        });
    };

    $scope.dunningsCount = 0;
    function updatedDunningsCount() {
        DunningsCount.get({ drafts: false }, function (data) {
            $scope.dunningsCount = (data && data.Count) ? data.Count : 0;
        });
    }

    if ($scope.customerId)
        $scope.customer = Customer.get({ customerId: $scope.customerId });


    // ReSharper disable JsUnreachableCode
    gettext('Resend Document');
    gettext('ArchiveOnly');
    gettext('Email');
    gettext('SnailMail');
    // ReSharper restore JsUnreachableCode
};
InvoiceController.$inject = ['$scope', '$http', '$routeParams', 'Invoice', 'Customer', 'InvoiceDownload',
    'InvoiceResend', 'InvoiceBearerMedium', 'InvoiceDownloadByFilter', 'gettextCatalog', 'gettext', 'DunningsCount',
    'PUtill', 'DatepickerUtils'];
